export default __webpack_public_path__ + "static/media/wn_7_1.8ac8c035.webp";